import SvgIcon from "@mui/material/SvgIcon";

interface AddConversationIconProps {
  children?: React.ReactNode;
  fontSize?: number | string;
  color?: string;
}

const AddConversationIcon: React.FC<AddConversationIconProps> = (props) => {
  return (
    <SvgIcon sx={{ fontSize: "inherit !important" }}>
      <svg
        id="plus-icon"
        height="512"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
        fill={props.color}
      >
        <path d="m256 .001c-141.158 0-255.999 114.841-255.999 255.999s114.841 255.999 255.999 255.999 255.999-114.84 255.999-255.999-114.841-255.999-255.999-255.999zm0 479.998c-123.513 0-223.999-100.486-223.999-223.999s100.486-223.999 223.999-223.999 223.999 100.485 223.999 223.999c0 123.513-100.486 223.999-223.999 223.999zm142-223.999c0 8.837-7.164 16-16 16h-110v110c0 8.837-7.164 16-16 16s-16-7.163-16-16v-110h-110c-8.836 0-16-7.163-16-16s7.164-16 16-16h110v-110c0-8.837 7.164-16 16-16s16 7.163 16 16v110h110c8.836 0 16 7.164 16 16z"></path>
      </svg>
    </SvgIcon>
  );
};

export default AddConversationIcon;
